import { useCallback } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';

import { useAxios } from '../context/AxiosContext';
import { toast } from 'react-toastify';

export function useUserData({ userId }: { userId: number }): any {
  const queryCache = useQueryClient();
  const { authAxios } = useAxios();

  const getUserInfo = useCallback(
    async ({ userId }): Promise<any[]> => {
      const response = await authAxios.get<any>(`/users/client-reps/${userId}`);
      return response.data;
    },
    [authAxios]
  );

  const updateUsersMutation = useMutation(
    async (data) => {
      const response = await authAxios.put('/users/client-reps', { users: data });

      return response.data;
    },
    {
      onSuccess: (data, variables) => {
        queryCache.invalidateQueries('client-reps');
        data.manageClientRep.clientRep.forEach(({ id }: any) => queryCache.invalidateQueries(['userData', Number(id)]));
        toast.success('Successfully updated user', {
          position: 'top-center'
        });
      },
      onError: () => {
        toast.error('Failed to update user', { position: 'top-center' });
      }
    }
  );

  const reactQuery = useQuery(['userData', userId], () => getUserInfo({ userId }), {
    refetchOnWindowFocus: false,
    enabled: userId !== null
  });

  return {
    ...reactQuery,
    updateUser: updateUsersMutation.mutateAsync
  };
}
